<div class="sub-link nav-sub-link-style" *ngFor="let link of links">
  <cigna-nav-item
    [navItem]="link"
    [dataTestAttribute]="'primary-nav-child-' + link.identifier"
    [isImpersonator]="isImpersonator"
  ></cigna-nav-item>
</div>
